export default "__VITE_ASSET__BC2uljPb__"